import { Component, Input } from '@angular/core';
import { ThemeType } from 'src/app/shared/models';
import { SectionLogo } from 'src/app/shared/models/section-logo';

@Component({
    selector: 'app-footer-logo',
    templateUrl: './footer-logo.component.html',
    styleUrls: ['./footer-logo.component.scss'],
    standalone: false,
})
export class FooterLogoComponent {
    public themeType = ThemeType;
    public sectionLogo = SectionLogo;

    @Input() width: string = '188';
    @Input() height: string = '47';
    @Input() customLogoName: string = '';
    @Input() isFullPath: boolean = false;
}
